import styled, { css } from 'styled-components';

export const CustomSorterWrapper = styled.div``;

export const LabelAndIconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 220px;
  margin-right: 15px;
  background: ${({ theme }) => theme.communityList.background};
  border: 2px solid ${({ theme }) => theme.communityList.borderColor};
  color: ${({ theme }) => theme.communityList.selectedColor};
  border-radius: 24px;
  height: 48px;
  padding: 0 15px;
  cursor: pointer;

  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 4px;
`;

export const CaretIcon = styled.i.attrs(({ icon }) => ({ className: icon }))`
  font-size: 16px;
  color: ${({ theme }) => theme.communityList.color};
  transition: transform 0.25s ease-in-out;

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;

export const DropDownListContainer = styled.div`
  position: absolute;
  z-index: 1;
  width: 220px;
  margin-top: 3px;
`;

export const DropDownList = styled.div`
  padding: 0px !important;
  margin: 0;
  padding-left: 1em;
  border-radius: 16px;
  box-sizing: border-box;
  color: #3faffa;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
`;

export const ListItem = styled.li`
  list-style: none;
  cursor: pointer;
  color: ${({ theme }) => theme.communityList.color};
  padding-left: 15px;
  line-height: 32px;
  border-radius: 16px;

  ${({ isTitle }) =>
    isTitle &&
    css`
      cursor: default !important;
    `}
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.communityList.dropdownBackground};
  border: 2px solid ${({ theme }) => theme.communityList.borderColor};
  color: ${({ theme }) => theme.communityList.selectedColor};
  padding: 15px;
  border-radius: 24px;
  position: relative;
`;

export const Title = styled.span`
  text-transform: uppercase;
  color: ${({ theme }) => theme.communityList.color};
  font-size: 13px;
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.communityList.selectedColor};
  line-height: 26.1px;
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  user-select: none;
`;

export const LabelContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
`;

export const AmountLabel = styled.span`
  color: ${({ theme }) => theme.communityList.color};
  font-size: 13px;
`;

export const ClearButton = styled.div`
  font-size: 12px;
  cursor: pointer;
  position: absolute;
  top: 18px;
  right: 15px;
  color: ${({ theme }) => theme.communityList.color};
`;

export const RatingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ClearRatingButton = styled.div`
  font-size: 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.communityList.color};
`;

export const FilterSection = styled.div`
  margin-bottom: 5px;
`;

export const KeywordsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
`;
